import 'babel-polyfill'

import Vue from 'vue'
import Vuex from 'vuex'
import VueLoading from 'vuex-loading'
import VeeValidate from 'vee-validate'
import VueClipboards from 'vue-clipboards'
import sparkline from 'vue-sparklines'

import app from '@/app'
import store from '@/store'
import router from '@/router'
import filters from '@/filters'

// production tips
Vue.config.productionTip = false

// vuex
Vue.use(Vuex)

// use filters
Vue.use(filters)

// vue loading
Vue.use(VueLoading)

// use validation
Vue.use(VeeValidate)

// use copy
Vue.use(VueClipboards)

Vue.use(sparkline)

/* eslint-disable no-new */
new Vue({
  store,
  router,
  el: '#app',
  template: '<app/>',
  components: { app },
  vueLoading: new VueLoading({ useVuex: true })
})



// WEBPACK FOOTER //
// ./src/main.js